var _g, _path, _g2, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_41_161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0H95V53H2L17.8341 26.5L2 0Z",
    fill: "#FA8C16"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41_161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 93,
    height: 53
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H95V53H2L17.8341 26.5L2 0Z",
    fill: "#EC652C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41_161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.633 9.13333H99.5333C99.2102 5.62437 97.6648 2.3404 95.1668 -0.145052C92.6689 -2.63051 89.3772 -4.1595 85.8667 -4.465V-8.63333C85.8667 -8.9958 85.7227 -9.34341 85.4664 -9.59971C85.2101 -9.85601 84.8625 -10 84.5 -10C84.1375 -10 83.7899 -9.85601 83.5336 -9.59971C83.2773 -9.34341 83.1333 -8.9958 83.1333 -8.63333V-4.465C79.635 -4.14433 76.3595 -2.60865 73.8754 -0.124599C71.3913 2.35946 69.8557 5.63501 69.535 9.13333H65.3667C65.0042 9.13333 64.6566 9.27732 64.4003 9.53362C64.144 9.78992 64 10.1375 64 10.5C64 10.8625 64.144 11.2101 64.4003 11.4664C64.6566 11.7227 65.0042 11.8667 65.3667 11.8667H69.535C69.8405 15.3772 71.3695 18.6689 73.8549 21.1668C76.3404 23.6648 79.6244 25.2102 83.1333 25.5333V29.6333C83.1333 29.9958 83.2773 30.3434 83.5336 30.5997C83.7899 30.856 84.1375 31 84.5 31C84.8625 31 85.2101 30.856 85.4664 30.5997C85.7227 30.3434 85.8667 29.9958 85.8667 29.6333V25.5333C89.3879 25.2254 92.688 23.6867 95.1873 21.1873C97.6867 18.688 99.2254 15.3879 99.5333 11.8667H103.633C103.996 11.8667 104.343 11.7227 104.6 11.4664C104.856 11.2101 105 10.8625 105 10.5C105 10.1375 104.856 9.78992 104.6 9.53362C104.343 9.27732 103.996 9.13333 103.633 9.13333ZM96.718 9.13333H92.618C92.3307 7.45145 91.5259 5.90108 90.3157 4.69826C89.1055 3.49543 87.5503 2.70007 85.8667 2.423V-1.677C88.6314 -1.36778 91.2096 -0.130475 93.1804 1.83292C95.1513 3.79632 96.3983 6.36983 96.718 9.13333ZM84.5 15.9667C83.4188 15.9667 82.3619 15.6461 81.4629 15.0454C80.5639 14.4447 79.8632 13.5909 79.4495 12.592C79.0357 11.5931 78.9274 10.4939 79.1384 9.43351C79.3493 8.37308 79.87 7.39901 80.6345 6.63448C81.399 5.86996 82.3731 5.34931 83.4335 5.13837C84.4939 4.92744 85.5931 5.0357 86.592 5.44946C87.5909 5.86322 88.4447 6.56389 89.0454 7.46288C89.6461 8.36187 89.9667 9.4188 89.9667 10.5C89.9667 11.9499 89.3907 13.3403 88.3655 14.3655C87.3403 15.3907 85.9499 15.9667 84.5 15.9667ZM83.1333 -1.718V2.382C81.4514 2.66932 79.9011 3.47414 78.6983 4.68431C77.4954 5.89448 76.7001 7.44973 76.423 9.13333H72.323C72.6322 6.36864 73.8695 3.79043 75.8329 1.81958C77.7963 -0.15126 80.3698 -1.39832 83.1333 -1.718ZM72.282 11.8667H76.382C76.6693 13.5486 77.4741 15.0989 78.6843 16.3017C79.8945 17.5046 81.4497 18.2999 83.1333 18.577V22.677C80.3686 22.3678 77.7904 21.1305 75.8196 19.1671C73.8487 17.2037 72.6017 14.6302 72.282 11.8667ZM85.8667 22.718V18.618C87.5486 18.3307 89.0989 17.5259 90.3017 16.3157C91.5046 15.1055 92.2999 13.5503 92.577 11.8667H96.677C96.3678 14.6314 95.1305 17.2096 93.1671 19.1804C91.2037 21.1513 88.6302 22.3983 85.8667 22.718Z",
    fill: "#FF996D"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    width: 4,
    height: 94,
    fill: "#304A5D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_41_161",
    x: 0,
    y: 0,
    width: 95,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.4 0 0 0 0 0.168627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_41_161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_41_161",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOn);
export default __webpack_public_path__ + "static/media/flag_on.6d7bb3df93f6cb9c9a7cbe69f63f6b1e.svg";
export { ForwardRef as ReactComponent };